import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image'
import SavedArticlesIcon from '../../../assets/images/saved-articles-icon.svg';
import './mega-menu.scss';

const MegaMenu = ({ subMenu }) => {

    const redirect = subMenu.redireccionDeLaOpcion

    return (
        <div className="f-m-mega-menu">
            <div className="f-m-mega-menu__content">
                {subMenu.opcionesSubmenu && subMenu.opcionesSubmenu.map((item, index) => {
                    let initialPath = (redirect !== "/" && redirect != item.redireccionDeLaOpcion) ? redirect : ""
                    let restPath = item.redireccionDeLaOpcion === "null" || item.redireccionDeLaOpcion === redirect ? "" : item.redireccionDeLaOpcion
                    let fullRedirection = initialPath + restPath
                    return (
                        <div className={"f-m-mega-menu__col " + (subMenu.redireccionDeLaOpcion === "magazin/" ? "f-m-mega-menu__col__squeeze" : "")} key={index} >

                            <a className={"f-m-mega-menu__col-title " + (subMenu.redireccionDeLaOpcion === "magazin/" ? "__short" : "")}
                                href={fullRedirection}>
                                {((item.imagenDeLaOpcion != null) || (item.redireccionDeLaOpcion === "articulos-guardados/")) &&
                                    <div className={"f-m-mega-menu__title-icon " + (item.redireccionDeLaOpcion === "articulos-guardados/" ? "__raw" : "")}>
                                        {item.redireccionDeLaOpcion != "articulos-guardados/" ?
                                            <img
                                                src={item.imagenDeLaOpcion.file.url}
                                                alt={item.imagenDeLaOpcion.description}
                                                loading="lazy"
                                            />
                                            :
                                            <img
                                                src={SavedArticlesIcon}
                                                alt={"saved articles icon"}
                                                loading="lazy"
                                            />
                                        }
                                    </div>}
                                {item.nombreDeLaOpcion}
                            </a>
                            <ul>
                                {item.opcionesSubmenu && item.opcionesSubmenu.map((itemSub, indexsub) => {
                                    let initialPath = redirect && redirect != "/" && redirect != "null" ? redirect : ""
                                    let restPath = (item.redireccionDeLaOpcion && item.redireccionDeLaOpcion !== "/" && item.redireccionDeLaOpcion !== redirect ? item.redireccionDeLaOpcion : "")
                                    let fullRedirection = initialPath + restPath + itemSub.redireccionDeLaOpcion
                                    return (
                                        <li key={indexsub}>
                                            <div className="f-m-mega-menu__subMenu-link"
                                                onClick={
                                                    () => {
                                                        window.dataLayer = window.dataLayer || [];
                                                        window.dataLayer.push({
                                                            'event': 'trackEvent',
                                                            'eventCategory': 'ui :: menu :: ' + subMenu.nombreDeLaOpcion,
                                                            'eventAction': 'click',
                                                            'eventLabel': item.nombreDeLaOpcion + ' :: ' + itemSub.nombreDeLaOpcion
                                                        });

                                                        window.dataLayer = window.dataLayer || [];
                                                        window.dataLayer.push({
                                                            'event': 'trackGA4',
                                                            'event_type': 'user_interaction',
                                                            'section': 'home',
                                                            'action': 'click',
                                                            'element': item.nombreDeLaOpcion + ' :: ' + itemSub.nombreDeLaOpcion,
                                                            'flow': subMenu.nombreDeLaOpcion,
                                                            'screen_name': 'home'
                                                        });

                                                        location.href = fullRedirection
                                                    }
                                                }
                                            >{itemSub.nombreDeLaOpcion}
                                            </div>
                                            {itemSub.imagenDeLaOpcion != null &&
                                                <div className="f-m-mega-menu__subOp-image">
                                                    <GatsbyImage
                                                        image={itemSub.imagenDeLaOpcion.gatsbyImageData}
                                                        alt={itemSub.imagenDeLaOpcion.description}
                                                    />
                                                </div>}
                                        </li>

                                    )
                                })}
                            </ul>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default MegaMenu;